"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyForLocale = void 0;
var locale_1 = require("../locale");
// TODO: get currencies from Backend??
var getCurrencyForLocale = function (locale) {
    var countryKey = Object.keys(locale_1.allCountries).find(function (key) { return locale_1.allCountries[key].countryCode === locale.countryCode; });
    return locale_1.allCountries[countryKey].currency;
};
exports.getCurrencyForLocale = getCurrencyForLocale;
